import type { EditAreaTemplateApplication } from '@repo/api-contracts';
import { type MutationError, trpc } from '@/shared/api';

interface Options {
  readonly onSuccess?: (application: EditAreaTemplateApplication) => void;
}

/** 다른 상품의 최신 편집영역 기하를 가져온다(사진·마스크 제외). 적용과 같은 결과 모양이다. */
export const useCopyEditAreaFromProduct = ({ onSuccess }: Options = {}) => {
  const mutation = trpc.productManagement.editAreaTemplates.copyFromProduct.useMutation({
    onSuccess,
  });
  const error: MutationError | null = mutation.error;

  return { copyFromProduct: mutation.mutate, isPending: mutation.isPending, error };
};
